import React, { ChangeEvent } from "react";
import { Form } from "react-bootstrap";
import { StringWithFormat } from "../../types/Result";
import { SelectListOption } from "./Types";

export interface IProps {
    name: string,
    value: number,
    disabled?: boolean
    validationResults?: StringWithFormat[]
    onChange: (value: any) => void
    onBlur?: () => void
    layout?: 'horizontal' | 'vertical'
    option: SelectListOption
}

const RadioButtonListItem: React.FC<IProps> = ({ name, value, disabled, validationResults, onChange, onBlur, layout, option }) => {

    function onControlChange(e: ChangeEvent<HTMLInputElement>) {
        onChange(option.value);
    }

    let val: string|null = null;
    if (value && value != null)
        val = value.toString();

    let isValid = validationResults && validationResults.length > 0 ? false : true;
    const display = layout === 'vertical' ? 'block' : 'inline-block'

    return (
        <div style={{ marginTop: 10, marginRight: 10, display: display }}>
            <Form.Check type='radio' name={name} value={option.value} checked={option.value == val} disabled={disabled} onChange={onControlChange} isInvalid={!isValid} onBlur={onBlur} style={{ height: 20, width: 20, marginRight: 5 }} className="pull-left" />
            {option.label}
        </div>
    )

}
export default RadioButtonListItem;